module.exports = __webpack_public_path__ + "media/catalog/check-svgrepo-com-649d24a4.svg";